export default {
  init() {
    /**
     * Changing label of header wpml link
     */
    $('.lang-fr .appointment-header__wpml a').text('English');
    $('.lang-en .appointment-header__wpml a').text('Français');
  },
};
